/* eslint-disable */
module.exports = {
    'Home.title1': '关于我们',
	'Home.title2': '产品介绍',
	'Home.title3': '最新动态',
	'Home.title4': '合作方式',
	'Home.title5': '学生作品集',
	'Home.title6': '联系我们',
	'Home.title7': '业内领袖',
	'Home.text1': '一套世界领先的少儿编程好课',
  'Home.AI': '青少年人工智能教育专家',
  'Home.AI-1': '人工智能是时代的必修课',
  'Home.AI-2': '为什么要从小学习人工智能？',
  'Home.AI-3': '为什么要选择畅学？',
  'Home.AI-4': '青少年生成式人工智能培养方案',
  'Home.AI-5': '项目展示',
	'Home.text2': '打造一套世界一线的青少年生成式人工智能好课',
	'Home.entry1': '学校入口',
	'Home.entry2': 'VIP 入口',
	'Home.entry3': '网络课程',
	'Home.entry4': '师资培训',
	'Home.entry5': '幼儿园课程',
	'Home.text3': '“畅学编程”',
	'Home.text4': '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海畅学教育（畅学编程）是国家高新技术企业，教育部教育信息化技术标准委员会委员单位，与清华大学等共同制定了“青少年编程能力等级标准”；是教育部重点课题《指向计算思维能力培养的低龄段儿童编程教育实践研究》重要参与单位；是中国香港、新加坡等地区少儿编程重要师资培训单位。',
	'Home.text5': '作为微软全球合作伙伴，全球计算机科学教师协会会员，同时也是江苏省青少年智能教育专业委员会的秘书长单位，畅学教育倾力优化老师和学生共享的计算机科学教育平台，培养更优秀的少儿编程教师，组织有影响力的全国性少儿编程竞赛，不断完善信息化教育生态圈。',
	'Home.more': '更多详情',
    'Home.leaders': '教学内容',
	'Home.goCommunity': '进入社区',
	"Home.14": "导论课",
	"Home.15": "一级课程",
	"Home.16": "计算思维入门及软件",
	"Home.17": "基础",
	"Home.18": "计算思维提升及物联网",
	"Home.19": "提升",
	"Home.20": "精炼",
	"Home.21": "计算思维增强及人工智能",
	"Home.22": "计算思维完善与综合训练",
	"Home.23": "Python与树莓派",
	"Home.24": "JavaScript与网络编程",
	"Home.25": "二级课程",
	"Home.26": "三级课程",
	"Home.27": "四级课程",
	"Home.28": "五级课程",
	"Home.29": "六级课程",
	"Home.school": "开课学校",
	"Home.schoolText": "更多学校正在加入中",
	"introduction.training": "畅学编程拥有完善的师资培训平台，集在线师资培训、在线试听诊断、线下试 讲认证一体，建立全面的师资培训认证体系。",
	"introduction.hardware": "畅学编程集合软件和硬件的教育特点，通过编程控制硬件设备，完成各类创意 智能家居、智能车改装等，使用灵活的方案解决更复杂的问题。",
	"introduction.lab1-1": "畅学STEAM人工智能编程工作坊（以下简称：畅学AI编程工坊）是面向中小学的创新实验室，具有完整的国产知识产权，将科技创新与中国文化相结合，让孩子从小具备用计算机创造工具解决问题的思维和能力。现在上海、江苏等地数百所学校采用，数十万孩子学习，其知识体系和核心素养达成度效果达到国际一流水平。",
	"introduction.lab1-2": "区别于传统的基于单项技能的创新实验室（如：机器人实验室、软件编程实验室或3D创客实验室），它以STEAM教育理念为指导，配套多元化的信息设备，培养学生综合运用各种信息技术实现自我创造与梦想的能力！",
	"introduction.lab1-3": "同时，从娃娃抓起，培养国产信息技术生态实践者，是国家安全发展战略，也是畅学人的使命，实验平台及所有课程架构在以中晟宏芯CP1国产服务器为基础的私有云平台上，平台完美对接各类机器人教具、智能硬件教具、3D创客教具、无人机教具，并积极参与国家标准委员会中小学信息技术教育技术平台标准的制定，推动国产信息技术生态圈的发展。",
	"introduction.lab1-4": "学习过程中，学生首先通过畅学编程课程平台系统的课程，掌握以计算思维为主线的游戏化软件编程、智能硬件及物联网编程、人工智能及机器人编程、三维设计及打印编程，再通过畅学AI编程工坊的多元化设备综合运用这些知识能力，从无到有实现自己的梦想，打造自己创意产品！很好的满足了国家在基础教育中对信息素养教育的要求，全面培养学生计算思维及编程能力，提升学生信息素养，让学生适应人工智能时代发展需求。",
	"introduction.lab1-5": "当然，畅学STEAM人工智能编程工作坊也同时支持学生学习实践传统信息技术课程。",
	"introduction.lab2-1": "畅学STEAM人工智能编程工作坊受国家住建部部长、上海市市领导等赞赏。",
	"introduction.lab2-2": "2019年2月21日上午九时，国家住房和城乡建设部党组书记、部长王蒙徽，党组成员、副部长倪虹等领导，在中共上海市委常委、市政法委书记、副市长陈寅、市府副秘书长黄融、中共长宁区委书记王为人、区长顾洪辉、教育局王小柳书记、姚期局长等领导的陪同下，来到上海市建青实验学校视察调研用科技改变提升垃圾分类工作。",
	"introduction.lab2-3": "学生们利用在畅学编程课上学习的知识，在畅学STEAM人工智能编程工坊里动手实践，用物联网知识选出传感器、用3D打印知识做出垃圾筒外壳、用编程逻辑让垃圾筒智慧起来，真正实现自己的智慧垃圾分类，受到领导的一致赞赏好评，值得大力推广。",
	"introduction.systemTit": "课程体系",
	"introduction.trainTit": "师资培训",
	"introduction.hardwareTit": "教学硬件",
	"introduction.laboratoryTit": "创新实验室",
	"introduction.HappyCodingIntro": "HappyCoding编程工具",
	"introduction.laboratoryTit1": "STEAM人工智能编程工作坊",
	"system1.text1": "计算思维40%知识点的初步认识",
	"system1.text2": "学会创建计算机程序",
	"system1.text3": "用编程语言创建动画故事，并分享至朋友圈",
	"system1.text4": "用编程语言开发交互式游戏，并分享至朋友圈",
	"system1.text5": "锻炼逻辑思维能力，提升信息素养建立初步工程意识",
	"system2.text1": "计算思维50%知识点的基本理解",
	"system2.text2": "开发更加复杂的交互游戏",
	"system2.text3": "学习硬件组成原理",
	"system2.text4": "初识人工智能的基本原理",
	"system2.text5": "通过编程控制物理世界，完成各类创意智能家居",
	"system2.text6": "具备参加全国青少年科技创新大赛的基本能力",
	"system3.text1": "计算思维80%知识点的理解",
	"system3.text2": "理解网络并具备基本的网络安全意识",
	"system3.text3": "开发简单的应用软件",
	"system3.text4": "通过编程控制运动设备，完成创意智能车的改装",
	"system3.text5": "使用更灵活的方案来解决更复杂的问题",
	"system4.text1": "计算思维100%知识点的理解",
	"system4.text2": "具有基本的工程意识",
	"system4.text3": "具备简单的数据查询分析能力",
	"system4.text4": "开发具有数据处理能力的应用软件",
	"system4.text5": "认识深度学习的训练体系",
	"system4.text6": "具备基本的人工智能+思维",
	"system5.text1": "综合运用计算思维解决实际问题",
	"system5.text2": "制作、开发手机APP",
	"system5.text3": "能用python编写程序",
	"system5.text4": "具备获得国家相关奖项的能力",
	"system6.text1": "能运用计算思维创造新工具",
	"system6.text2": "能用python编写WEB应用",
	"system6.text3": "能用python操作开源硬件",
	"system6.text4": "能用python调用人工智能",
	"system6.text5": "具备获得国家相关奖项能力",
	"system.text1": "培养目标",
	"scratch.All": "全部",
	"scratch.Animations": "动画",
	"scratch.Art": "艺术",
	"scratch.Games": "游戏",
	"scratch.Music": "音乐",
	"scratch.Stories": "故事",
	"scratch.Tutorials": "教程",
	"scratch.trending": "趋势",
	"scratch.popular": "流行",
	"scratch.recent": "最新",
	"Product.systemDetection": "系统检测",
	"DownChromeTip": "下载适用于您的",
	"ChromeBrower": "Chrome 浏览器",
}



// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js